import styled, { css } from 'styled-components';
import { AudioPlayer } from 'src/components';

export const PromptAudio = styled(AudioPlayer)(
  ({ theme }) => css`
    height: 100%;
    min-height: ${theme.sz.s40};
    min-width: ${theme.sz.s40};
    max-height: calc(${theme.sz.xs} + ${theme.sz.s6});
    max-width: calc(${theme.sz.xs} + ${theme.sz.s6});

    @media (min-width: 40rem) {
      min-height: ${theme.sz.xs};
      min-width: ${theme.sz.xs};
      max-height: calc(${theme.sz.xs} + ${theme.sz.s16});
      max-width: calc(${theme.sz.xs} + ${theme.sz.s16});
    }
  `,
);

export const PromptText = styled.h2<{
  $textSize: 'medium' | 'large' | 'small';
}>(
  ({ theme, $textSize }) => css`
    color: ${theme.co.neutral20};
    font-family: ${theme.DEPRECATED_ty.openSans};
    font-size: ${$textSize === 'medium' && theme.DEPRECATED_ty.largest};
    font-size: ${$textSize === 'large' && theme.DEPRECATED_ty.display};
    font-size: ${$textSize === 'small' && theme.DEPRECATED_ty.large};
  `,
);

export const PromptImage = styled.img(
  ({ theme }) => css`
    object-fit: contain;
    object-position: center;
    border: 0;
    margin: ${theme.sz.s4} auto;
    min-height: ${theme.sz.s40};
    min-width: ${theme.sz.s40};
    max-height: calc(${theme.sz.xs} + ${theme.sz.s6});
    max-width: calc(${theme.sz.xs} + ${theme.sz.s6});
    width: 100%;
    height: 100%;

    @media (min-width: 40rem) {
      max-width: calc(${theme.sz.s4} + 40vh);
      min-width: calc(${theme.sz.s4} + 40vh); /* prevent screen jumping during rendering */
    }
  `,
);
